import { useState } from 'react'
import { Button } from '@/shared/ui/button'
import { Dialog } from '@/shared/ui/dialog'
import { useCancelMeeting, useEndMeeting } from '../model/use-end-meeting'

interface EndMeetingControlProps {
  meetingId: string
  mode: 'end' | 'cancel'
  onDone?: () => void
}

const copy = {
  end: {
    action: 'Завершить встречу',
    question: 'Завершить встречу для всех участников? Отменить это действие нельзя.',
    confirm: 'Завершить',
  },
  cancel: {
    action: 'Отменить встречу',
    question: 'Отменить запланированную встречу?',
    confirm: 'Отменить встречу',
  },
} as const

export function EndMeetingControl({ meetingId, mode, onDone }: EndMeetingControlProps) {
  const [open, setOpen] = useState(false)
  const end = useEndMeeting(meetingId)
  const cancel = useCancelMeeting(meetingId)
  const mutation = mode === 'end' ? end : cancel
  const text = copy[mode]

  function run() {
    mutation.mutate(undefined, {
      onSuccess: () => {
        setOpen(false)
        onDone?.()
      },
    })
  }

  return (
    <>
      <Button variant="danger" size="sm" onClick={() => setOpen(true)}>
        {text.action}
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} title={text.action}>
        <p className="text-sm text-text-secondary">{text.question}</p>
        <div className="mt-4 flex justify-end gap-3">
          <Button variant="secondary" size="sm" onClick={() => setOpen(false)}>
            Не сейчас
          </Button>
          <Button variant="danger" size="sm" disabled={mutation.isPending} onClick={run}>
            {text.confirm}
          </Button>
        </div>
      </Dialog>
    </>
  )
}
